export default __webpack_public_path__ + "static/media/coins.b184c8fb.png";